import { HeadCell } from '../../../models/TableProps';
import { LiveOrdersHeadCellContent } from '../../../models/LiveOrders';

export const LIVE_ORDERS_HEAD_CELLS: HeadCell<LiveOrdersHeadCellContent>[] = [
    {
        id: 'orderID',
        numeric: false,
        disablePadding: false,
        label: 'ORDER_NUMBER',
        sortable: true,
    },
    {
        id: 'orderDate',
        numeric: true,
        disablePadding: false,
        label: 'DATE',
        sortable: true,
    },
    {
        id: 'netAmount',
        numeric: true,
        disablePadding: false,
        label: 'PRICE_NET',
        sortable: true,
    },
    {
        id: 'amountInclVAT',
        numeric: true,
        disablePadding: false,
        label: 'PRICE_GROSS',
        sortable: true,
    },
    {
        id: 'status',
        numeric: true,
        disablePadding: false,
        label: 'STATUS',
        sortable: true,
    },
    {
        id: 'more',
        numeric: true,
        disablePadding: false,
        label: 'MORE',
        sortable: false,
    },
];
